import { z } from "zod";

const encyclopediaColumnItemSchema = z.discriminatedUnion("type", [
	z.object({
		type: z.literal("text-block"),
		title: z.string().nonempty().optional(),
		content: z.string().nonempty().optional(),
	}),
	z.object({
		type: z.literal("photo-block"),
		background: z.string().nonempty().optional(),
		images: z.array(
			z.object({
				src: z.string().nonempty(),
				name: z.string().nonempty(),
			})
		),
	}),
	z.object({
		type: z.literal("image-block"),
		image: z.string().nonempty(),
	}),
]);
export type EncyclopediaColumnItemType = z.infer<
	typeof encyclopediaColumnItemSchema
>;

export const encyclopediaPageSchema = z.object({
	letter: z.string().nonempty().optional(),
	columns: z.array(z.array(encyclopediaColumnItemSchema)).length(2),
});
export type EncyclopediaPageType = z.infer<typeof encyclopediaPageSchema>;
